﻿$.fn.dxCtrlSelectModelebt = function custom_dxCtrlSelectModelebt(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlselectmodelebt dx-ctrl");
        this.createInstance(new cdxCtrlSelectModelebt(this, option));
    }
    return this;
}

window.cdxCtrlSelectModelebt = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty()
        var width = 240
        container.css({
            "display": "inline-block",
            "width": width + "px",
            "height": (width * 3 / 2.4) + "px",
            "margin": "10px",
            "overflow": "hidden",
            "position": "relative",
            "border": theme.border,
            opacity: "0.8"
        })
        //var $DivIframe = $("<div style='position:absolute;top:0;left:0;height:100%;width:100%;'/>").appendTo(container)
        var dxCtrlIframeResize = null
        if (typeof option.icon != 'undefined') {
            var $Div = $("<div style='width:100%;height:100%;display:flex;align-items:center;justify-content:center;'/>").appendTo(container)
            $("<i class='" + option.icon + "' style='font-size:900%;margin-bottom:40px;'></i>").appendTo($Div)
        } else {
            if (isPartiallyInViewport(container)) {
                window.setTimeout(function () { mRempliInterne() }, 200 * ((typeof option.index != 'undefined') ? option.index : 0))
            } else {
                observerAvecCallback(container[0], function (target, isVisible) {
                    if (isVisible) { mRempliInterne() }
                    else {
                        if (dxCtrlIframeResize) {
                            dxCtrlIframeResize.element().remove()
                            dxCtrlIframeResize=null
                        }
                    }
                });
            }

            function mRempliInterne() {
                var scale = 0.6
                var hw = 100 * 1 / scale
                if (typeof option.src == 'undefined') {
                    //on a pas le src, on appelle le serveur pour récupérer le src
                    var jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance")
                    jauge.mShow()
                    option.bddCtrl.mAjaxCall({
                        command: "getUrlHtmlemailcourrierdoccptbox",
                        path_nom_fichier: option.pathNomFichier,
                        type: option.type
                    }, function (data) {
                        option.src = data.urlhtml
                        mRempliIframe()
                        jauge.mHide()
                    })
                } else {
                    mRempliIframe()
                }
                function mRempliIframe() {
                    dxCtrlIframeResize = $("<div style='transform:scale(" + scale + ");transform-origin: 0 0;width:" + hw + "%;height:" + hw + "%;'/>").appendTo(container).dxCtrlIframeResize({
                        disabled: true,
                        src: option.src,
                        onClick: function (e) {
                            var dxScrollPopup = null
                            var dxIframeTot = null
                            var popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
                                fullScreen: true,
                                showMaximize: false,
                                title: option.nom,
                                tdTitleTemplate: function (titleElement) {
                                    titleElement.css("width", "130px")
                                    var dxBt2 = $("<div style=''/>").appendTo(titleElement).dxCtrlButton({
                                        text: "Choisir",
                                        width: "100%",
                                        onClick: function (e) {
                                            popup.hide()
                                            option.onClick()
                                        }
                                    }).dxCtrlButton("instance")
                                },
                                contentTemplate: function (contentElement) {
                                    contentElement.css("padding-top", 0)
                                    contentElement.css({
                                        "display": "inline-block",
                                        "position": "relative",
                                    })
                                    dxScrollPopup = $("<div/>").appendTo(contentElement).dxScrollView({}).dxScrollView("instance")
                                    dxIframeTot = $("<div style='min-height:" + dxScrollPopup.element().find(".dx-scrollable-container").innerHeight() + "px'/>").appendTo(dxScrollPopup.content()).dxCtrlIframeResize({
                                        disabled: true,
                                        src: option.src,
                                        onContentReady: function (component) {
                                            component.element().find("iframe").css("min-height", "100%")
                                            component.element().find("iframe").removeAttr("scrolling")
                                        }
                                    }).dxCtrlIframeResize("instance")
                                },
                                onShown: function (e) {
                                    dxIframeTot.element().css("min-height", dxScrollPopup.element().find(".dx-scrollable-container").innerHeight() + "px")
                                    resizeObserver.mAdd(dxScrollPopup.element().find(".dx-scrollable-container"), function () {
                                        dxIframeTot.element().css("min-height", dxScrollPopup.element().find(".dx-scrollable-container").innerHeight() + "px")
                                    })
                                }
                            }).dxCtrlPopupBase("instance")
                            popup.show()
                        },
                        onContentReady: function (component) {
                            component.element().find("iframe").css("min-height", "100%")
                            component.element().find("iframe").removeAttr("scrolling")
                        }
                    }).dxCtrlIframeResize("instance")
                }
            }
        }

        var $DivTitle = $("<div style='position:absolute;bottom:0;height:50px;left:0;width:100%;background-color:" + theme.backgroundcolorTooltip + ";display:flex;align-items:center;opacity:0.8;z-index:1;'></div>").appendTo(container)
        var nom = option.nom
        if (nom.startsWith("signature_signature") || nom.startsWith("signature_Signature")) nom = nom.replace("signature_signature", "Signature").replace("signature_Signature", "Signature")
        var $DivNom = $("<div style='padding:10px 14px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;font-family:barlow condensed;font-size:120%;'>" + nom + "<div/>").appendTo($DivTitle)
        var dxBt = $("<div style='display:none;width:100%;margin:0 20px;'/>").appendTo($DivTitle).dxCtrlButton({
            text: "Choisir",
            width: "100%",
            onClick: function (e) { option.onClick() }
        }).dxCtrlButton("instance")

        if (option.allowDelete) {
            var dxBtDel = $("<div style='position:absolute;top:5px;right:5px;display:none;'/>").appendTo(container).dxCtrlButton({
                icon: "fas fa-trash-alt",
                onClick: function (e) {
                    e.event.stopPropagation()
                    //pathNomFichier
                    container.remove()
                    var traitement = new cFileManagerAction(option.bddCtrl, option.pathNomFichier, "supprimer", function () {
                    })
                    traitement.mStartTraitement()
                }
            }).dxCtrlButton("instance")
        }
        //container.on("mouseenter", function () { container.css("opacity", "1"); })
        container.on("mouseenter", function () {
            $DivNom.hide();
            dxBt.element().show();
            container.css("opacity", "1");
            if (dxBtDel) dxBtDel.element().show()
        })
        //container.on("mouseleave", function () { container.css("opacity", "0.8"); })
        container.on("mouseleave", function () {
            $DivNom.show();
            dxBt.element().hide();
            container.css("opacity", "0.8");
            if (dxBtDel) dxBtDel.element().hide()
        })
    }

    this.element = function () { return container }

    mConstruit();
}